<div class="table mt-0100"
     *ngIf="entity">

  <!--Menu Button Template-->
  <mat-menu class="popover__menu ignore-click"
            #addressMenu="matMenu">
    <ng-template matMenuContent
                 let-address="address">
      <ng-container *ngIf="isBad(address); then badButtons else goodButtons">
      </ng-container>

      <ng-template #badButtons>
        <button mat-menu-item
                (click)="onSetStatus(address, 'user_added')">
          <span class="link link--green link--noline">Restore</span>
        </button>
      </ng-template>

      <ng-template #goodButtons>

        <button mat-menu-item
                (click)="onEdit(address)">Edit
        </button>
        <button mat-menu-item
                (click)="onEditGeocode(address)">
          Edit Geocode
        </button>
        <button mat-menu-item
                *ngIf="isNormalized(address)"
                (click)="onRevertAutoCorrect(address)">
          Undo Address Autocorrect
        </button>
        <button mat-menu-item
                *ngIf="!isVerified(address)"
                (click)="onSetStatus(address, 'verified')">
          <span class="link link--green link--noline">Mark as confirmed</span>
        </button>
        <button mat-menu-item
                *ngIf="isVerified(address)"
                (click)="onSetStatus(address, 'user_added')">
          Unmark as confirmed
        </button>


        <mat-divider></mat-divider>
        <button mat-menu-item
                *ngIf="!isDoNotContact(address)"
                (click)="onSetStatus(address, 'do_not_contact')">
          <span class="link link--noline link--red">Mark as do not contact</span>
        </button>
        <button mat-menu-item
                *ngIf="isDoNotContact(address)"
                (click)="onSetStatus(address, 'user_added')">

          Unmark as do not contact
        </button>


        <button mat-menu-item
                (click)="onSetStatus(address, 'bad')">
          <span class="link link--noline link--red"
                data-test-id="markAsBad">Mark as bad</span>
        </button>
      </ng-template>
    </ng-template>
  </mat-menu>

  <div class="tr tr--noGutter tile__heading pt-0 pb-0">
    Addresses
    <ng-container *ngIf="showTaskDoneMark">
      <span class="color--gray ml-0050">
        &bull;
        <span class="color--green">
          <span class="d-none d-inline--md uppercase ml-0025">Done</span>
          <i class="far fa-check ml-0025"></i>
        </span>
      </span>
    </ng-container>
    <button *ngIf="!readonly"
            mat-button
            disableRipple
            class="addNew ml-auto mat-button--no-focus-overlay"
            (click)="onAddNew()">
      <i class="far fa-plus addNew__icon"></i>
      Add
    </button>
  </div>

  <div class="tr trContact"
       *ngFor="let address of sortByBest(entity.addresses, showBad)"
       [ngClass]="{'tr--red': isBad(address)}">
    <div class="tc trContact__title d-block">
      <div class="w-100 d-flex max-width-100">
        <full-address class="full-address"
                      style="text-overflow:ellipsis;overflow:hidden"
                      [address]="address"
                      [noLink]="isDoNotContact(address)"
                      [additionalClasses]="{'color--gray--007' : isDoNotContact(address)}">
        </full-address>
        <i class="fas fa-ban color--red pair__verified ml-0050"
           *ngIf="isDoNotContact(address)"
           matTooltip="Marked as Do Not Contact"
           matTooltipPosition="above"></i>
        <i class="far fa-times-circle pair__red ml-0050"
           *ngIf="isBad(address)"
           matTooltip="Marked as Bad"
           matTooltipPosition="above"></i>
        <i class="far fa-check pair__verified ml-0050"
           *ngIf="isVerified(address)"
           matTooltip="Confirmed"
           matTooltipPosition="above"></i>
        <i class="far fa-location-slash pair__red ml-0050"
           *ngIf="isGeocodeBad(address)"
           matTooltip="Geocode is marked as bad"
           matTooltipPosition="above"></i>
      </div>

      <div *ngIf="showElectoralDistricts"
           class="w-100 mt-0025 tc--xs sep-list normal-wrap">
        <span *ngFor="let district of getDistricts(address)"
              matTooltip="{{district.longName}}"
              class="sep">
          {{district.name}}
        </span>
      </div>

    </div>

    <div class="tc tc--xs trContact__type">
      {{address.addressType | propercase}}
    </div>

    <div class="tc tc--xs trContact__type">
      {{address.source | source}}
    </div>

    <div class="tc tc--light tc--xs trContact__meta"
         title="{{address.updatedAt|date:'medium'}}">
      Edited {{address.updatedAt | relativeDate}}
    </div>


    <div class="tr__drawer tr__drawer--sm drawer">
      <button *ngIf="!readonly"
              class="drawer__btn"
              type="button"
              [matMenuTriggerFor]="addressMenu"
              [matMenuTriggerData]="{address: address}">
        <i class="far fa-fw fa-ellipsis-h fa--gray"></i>
      </button>
    </div>
  </div>

  <div class="tr tr--noGutter tr--sm tr--gray"
       *ngIf="getBadCount(entity.addresses) > 0">
    <div class="addNew addNew--red ml-auto mr-0025"
         (click)="showBad = !showBad"
         data-test-id="toggleAddressesShowBad">
      <ng-container *ngIf="!showBad">
        <span class="addNew__text">
          View Bad (<strong data-test-id="addressesBadCount">{{getBadCount(entity.addresses)}}</strong>)
        </span>
        <i class="far fa-chevron-down ml-0050 addNew__text--gray"></i>
      </ng-container>
      <ng-container *ngIf="showBad">
        <span class="addNew__text">
          Hide Bad (<strong data-test-id="addressesBadCount">{{getBadCount(entity.addresses)}}</strong>)
        </span>
        <i class="far fa-chevron-up ml-0050 addNew__text--gray"></i>
      </ng-container>
    </div>
  </div>

</div>
